import React from 'react';

const SliderItem = ({ data }) => {
    const { bg, text } = data;
    return (
        <div className="item">
            <div
                className="slide_item" style={{ backgroundImage: `url(${bg})` }}
            >
                <div className="container">
                    <div className="slide_item_content">
                        <div className="slide_item_text">{text}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SliderItem;